import request from "@/utils/request";
import { formateObjToParamStr } from "@/utils";
// import { encryptByDES } from '@/utils/crypto'
import qs from "qs";
import axios from "axios";
const BASE_API = process.env.VUE_APP_BASE_API;
const REAL_BASE_API =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_REAL_BASE_API
    : process.env.VUE_APP_BASE_API;
const LOGIN_API = process.env.VUE_APP_LOGIN_API;

export function getWordTs(param) {
  return request({
    url: `${BASE_API}/api/get_gamazon_ts`,
    method: "get",
    params: param,
  });
}
export function getCatTree(param) {
  return request({
    url: `${BASE_API}/api/cats_tree`,
    method: "get",
    params: param,
  });
}
export function getAmazonData(param) {
  return request({
    url: `${BASE_API}/api/list_gamazon`,
    method: "get",
    params: param,
  });
}
export function getScatterDataUrl(param) {
  return `${REAL_BASE_API}/api/list_gamazon?` + formateObjToParamStr(param);
}

export function getBrandScatterDataUrl(param) {
  return `${REAL_BASE_API}/api/oversea_brands?` + formateObjToParamStr(param);
}

export function getCatsScatterDataUrl(param) {
  return `${REAL_BASE_API}/api/oversea_cats?` + formateObjToParamStr(param);
}

export function getAmazonDetailData(param) {
  return request({
    url: `${BASE_API}/api/gamazon_search`,
    method: "post",
    data: param,
  });
}

export function getSalesTrendDownUrl(param) {
  //亚马逊详情页销售趋势下载接口
  return `${REAL_BASE_API}/api/word?` + formateObjToParamStr(param);
}

export function getOverseaBrandsData(param) {
  return request({
    url: `${BASE_API}/api/oversea_brands`,
    method: "get",
    params: param,
  });
}

export function getOverseaCatsData(param) {
  return request({
    url: `${BASE_API}/api/oversea_cats`,
    method: "get",
    params: param,
  });
}

export function getOverseaTs(param) {
  return request({
    url: `${BASE_API}/api/get_oversea_ts`,
    method: 'get',
    params: param,
  });
}

export function getOverseaPlat(param) {
  return request({
    url: `${BASE_API}/api/get_oversea_plat`,
    method: 'get',
    params: param,
  });
}

export function getLatestTime(param) {
  return request({
    url: `${BASE_API}/api/latesttime`,
    method: 'get',
    params: param,
  })
}